import { Node } from '@tiptap/core';
import { PasteRule } from '@tiptap/react';
import Suggestion from '@tiptap/suggestion';
import { SearchIndex } from 'emoji-mart';
import { PluginKey } from 'prosemirror-state';
import { renderEmojiPopup } from './options';
export const EmojiPluginKey = new PluginKey('emoji');
const defaultSuggestions = [
    {
        id: '+1',
        shortcodes: ':+1:',
        native: '👍',
    },
    {
        id: 'heart',
        shortcodes: ':heart:',
        native: '❤️',
    },
    {
        id: 'tada',
        shortcodes: ':tada:',
        native: '🎉',
    },
    {
        id: 'smile',
        shortcodes: ':smile:',
        native: '😄',
    },
    {
        id: 'open_mouth',
        shortcodes: ':open_mouth:',
        native: '😮',
    },
    {
        id: 'cry',
        shortcodes: ':cry:',
        native: '😢',
    },
];
const EMOJI_INPUT_REGEX = /:([^:\s]*(?:::[^:\s]*)*):/g;
export const Emoji = Node.create({
    name: 'emoji',
    addOptions() {
        return {
            HTMLAttributes: {},
            suggestion: {
                char: ':',
                pluginKey: EmojiPluginKey,
                items: async ({ query }) => {
                    if (!query || query.length < 1)
                        return defaultSuggestions;
                    const results = await SearchIndex.search(query, { maxResults: 20 });
                    return results.map(it => {
                        var _a, _b;
                        return ({
                            id: it.id,
                            native: (_a = it.skins[0]) === null || _a === void 0 ? void 0 : _a.native,
                            shortcodes: (_b = it.skins[0]) === null || _b === void 0 ? void 0 : _b.shortcodes,
                        });
                    });
                },
                // TODO: @Mehrad we should pass the document from the `useDocument` hook
                render: () => renderEmojiPopup({ document }),
                command: ({ editor, range, props }) => {
                    var _a;
                    // increase range.to by one when the next node is of type "text"
                    // and starts with a space character
                    const { nodeAfter } = editor.view.state.selection.$to;
                    const overrideSpace = (_a = nodeAfter === null || nodeAfter === void 0 ? void 0 : nodeAfter.text) === null || _a === void 0 ? void 0 : _a.startsWith(' ');
                    if (overrideSpace) {
                        range.to += 1;
                    }
                    editor
                        .chain()
                        .focus()
                        .insertContentAt(range, [
                        {
                            type: 'text',
                            text: props.native,
                        },
                        {
                            type: 'text',
                            text: ' ',
                        },
                    ])
                        .run();
                },
            },
        };
    },
    group: 'inline',
    inline: true,
    atom: true,
    addPasteRules() {
        const pasteRule = new PasteRule({
            find: EMOJI_INPUT_REGEX,
            handler: async ({ state, range, match }) => {
                var _a;
                const emojiSuggestions = await SearchIndex.search(match[1], {
                    maxResults: 1,
                });
                if (!emojiSuggestions || (emojiSuggestions === null || emojiSuggestions === void 0 ? void 0 : emojiSuggestions.length) < 1) {
                    return;
                }
                const emoji = emojiSuggestions[0];
                const insert = (_a = emoji === null || emoji === void 0 ? void 0 : emoji.skins[0]) === null || _a === void 0 ? void 0 : _a.native;
                const start = range.from;
                const end = range.to;
                state.tr.insertText(insert, start, end);
            },
        });
        return [pasteRule];
    },
    addProseMirrorPlugins() {
        return [
            Suggestion({
                editor: this.editor,
                ...this.options.suggestion,
            }),
        ];
    },
});
//# sourceMappingURL=index.js.map